export default {
    state: {
      defaultData: {},
    },
  
    getters: {
      getScheduleData(state) {
        return state.defaultData;
      },
    },
  
    mutations: {
      setScheduleData(state, data) {
        const isNull = data === null;
  
        state.defaultData = {
          id: !isNull ? data.id : "",
          unity_reference_id: !isNull ? Number(data.unity_reference_id) : "",
          unity: !isNull ? data.unity : "",
          datetime_schedule: !isNull ? data.datetime_schedule : "",
          qty_vacancies: !isNull ? Number(data.qty_vacancies) : "",
          emails : !isNull ? data.emails : [],
          event: !isNull ? data.event : "",
          event_id: !isNull ? Number(data.event_id) : "",
          name:  !isNull ? data.name : "",
          doctor_name:  !isNull ? data.doctor_name : "",
          speciality_id:  !isNull ? Number(data.speciality_id) : "",
          health_center_id:  !isNull ? Number(data.health_center_id) : "",
        };
      },
    },
  
    actions: {
      changeScheduleData(context, infos) {
        context.commit("setScheduleData", infos);
      },
    },
  };